import { Component, Inject, OnInit } from '@angular/core';import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
;

@Component({
  selector: 'app-edit-comment-dialog',
  templateUrl: './edit-comment-dialog.component.html',
  styleUrls: ['./edit-comment-dialog.component.scss']
})
export class EditCommentDialogComponent implements OnInit {
 
  constructor(public dialogRef:MatDialogRef<EditCommentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,) { }
    QuestionId=this.data.QuestionId;
    QuestionComment=this.data.comment_;
  ngOnInit() {
  }
  DialogClose(){
    this.dialogRef.close()
    
  }

  SaveQuestionComments(){
    
    this.dialogRef.close(this.QuestionComment)
  }
}
